import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const HeaderActionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.S12};
`
